/*=========================================================================================
  File Name: module-usertax-state.js
  Description: UserTax Module State
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

/**
 * Vuex State Module cho Report
 * Quản lý state của các báo cáo trong hệ thống
 * @author Team InvoiceBot
 */
export default {
	// Báo cáo hóa đơn rủi ro
	InvoiceRisk: [],
	InvoiceRiskTotal: 0,
	IsLoadingTotalInvoiceRiskRecords: false,

	// Báo cáo hóa đơn theo tình trạng hoạt động NCC
	InvoiceSupplierActives: [],
	InvoiceSupplierActiveTotal: 0,
	IsLoadingInvoiceSupplierActiveTotal: false,

	// Báo cáo hóa đơn liên quan (thay thế, điều chỉnh)
	InvoiceRelateds: [],
	InvoiceRelatedTotal: 0,
	IsLoadingInvoiceRelatedTotal: false,

	// Báo cáo tổng hợp chi phí
	CostTypeSummaryReportTotal: 0,
	DataCostTypeSummaryReport: [],
	IsLoadingCostTypeSummaryReportTotal: false,

	// Báo cáo hóa đơn vượt định mức chi phí
	DataReportExceedCost: [],
	ReportExceedCostTotal: 0,
	IsLoadingReportExceedCostTotal: false,

	// Báo cáo thống kê chi phí theo nhãn dán
	InvoiceStick: [],
	InvoiceStickTotal: 0,
	InvoiceListForStickTotal: 0,
	IsLoadingInvoiceStickTotal: false,

	// Báo cáo loại chi phí và định mức
	TypeAndCostTotal: 0,
	DataTypeAndCost: [],
	IsLoadingTypeAndCostTotal: false,
	DataTypeAndCostDataPage: [],

	// Danh sách hóa đơn theo định mức
	InvoiceByNormTotal: 0,
	InvoiceByNorm: [],

	/**
	 * Danh sách chi tiết hóa đơn vượt ngưỡng 5 triệu
	 * @author dqduy 11.2025
	 */
	ListInvoicesExceed: [],
	InvoicesExceedTotal: 0
};
